<template>
  <send-modal
    :title="title"
    :change-display="changeDisplay"
    :selected-responses-ids="selectedResponsesIds"
    :responses="responses"
    :create-send-data="createSendData"
    :initial-body="signature"
    :body_template="template"
    :is-link-share-shown="isLinkShareShown"
    api-method="shareLink"
  />
</template>

<script>
  import SendModal from './SendAbstract';

  export default {
    name: 'LinkShareModal',

    components: {
      SendModal
    },

    props: {
      changeDisplay: Function,
      responses: Array,
      selectedResponsesIds: Array,
      template: Object,
      isLinkShareShown: Boolean
    },

    computed: {
      signature() {
        return `\n\n\n${this.$tr('responses.shareLink.signature')}, ${
          this.$store.state.user.data.name
        }`;
      },

      title() {
        const count = this.selectedResponsesIds.length;
        return this.$tr('responses.shareLink.title', count, {
          is_pluralization: true
        });
      }
    },

    methods: {
      createSendData(component) {
        return {
          links: component.recipients.reduce((links, recipient) => {
            const mails = component.sendingCandidates.map(sendingCandidate => {
              return {
                subject: component.subject,
                body: component.body,
                response: {
                  id: sendingCandidate.id
                },
                user: {
                  email: recipient.email
                }
              };
            });
            return links.concat(mails);
          }, [])
        };
      }
    }
  };
</script>
